'use client';

import LucideIcon from '@/components/ui/LucideIcon';
import { Flex, Grid, Text } from '@chakra-ui/react';
import SectionContainer from '@/components/shared/SectionContainer';
import { SafeLink } from '@/components/ui/SafeLink';
import SalePointCard from './components/SalePointCard';
import { salePoints } from './constants/salePoints';

const WhySkinSeoulSection = () => {
  return (
    <SectionContainer
      containerInnerProps={{
        backgroundColor: 'common.0',
        paddingY: { base: 10, tablet: 16 },
      }}
    >
      <Flex direction="column" width="100%" marginBottom={{ base: 8, tablet: 12 }}>
        <SafeLink href="/about-us/" width="100%" _hover={{ textDecoration: 'none' }}>
          <Flex
            alignItems="center"
            width="100%"
            justify={{ base: 'space-between', tablet: 'start' }}
            gap={{ base: 3, tablet: 4 }}
          >
            <Text color="common.100" textStyle="heading2" fontWeight="regular">
              Why SkinSeoul?
            </Text>
            <LucideIcon name="ChevronRight" boxSize={6} color="common.100" />
          </Flex>
        </SafeLink>

        <Text color="text.subtle.inverse" textStyle="body2" fontWeight="regular">
          Here Are Four Reasons You&apos;ll Love Us
        </Text>
      </Flex>
      <Grid
        gap={{ base: 2, tablet: 3 }}
        templateColumns={{
          base: 'repeat(2, 1fr)',
          tablet: 'repeat(4, 1fr)',
        }}
        width="100%"
      >
        {salePoints.map((point) => (
          <SalePointCard icon={point.icon} key={point.subtitle} subtitle={point.subtitle} title={point.title} />
        ))}
      </Grid>
    </SectionContainer>
  );
};

export default WhySkinSeoulSection;
